
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(106|55|660|777)$/.test(chunkId);
},
rootOutputDir: "",

    };
}
